import { render, staticRenderFns } from "./luckyTable.vue?vue&type=template&id=40d148db&scoped=true&"
import script from "./luckyTable.vue?vue&type=script&lang=js&"
export * from "./luckyTable.vue?vue&type=script&lang=js&"
import style0 from "./luckyTable.vue?vue&type=style&index=0&id=40d148db&prod&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "40d148db",
  null
  
)

export default component.exports